import { IconProps } from "../../../types/style";

const RubbishSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 7.20789L14.1649 8.63521L4.03549 2.85994L4.87056 1.43262L7.40919 2.87644L8.54489 2.57117L12.1608 4.63377L12.4697 5.76407L15 7.20789ZM3 15.5325V5.63207H7.23382L13.0209 8.93222V15.5325C13.0209 15.9702 12.8449 16.3899 12.5317 16.6993C12.2185 17.0088 11.7937 17.1826 11.3507 17.1826H4.67015C4.2272 17.1826 3.80239 17.0088 3.48917 16.6993C3.17596 16.3899 3 15.9702 3 15.5325Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default RubbishSVG;
